import ApplicationModel from 'components/framework/ApplicationModel';
import Fragment from 'components/framework/Fragment';
import { type MutationBatcher } from 'components/framework/MutationBatcher';
import type Query from 'components/framework/Query';

interface TeamAssignableOptions {
  resetAttributes?: boolean;
  args?: {};
  query?: Query<any, any>;
  batcher?: MutationBatcher;
}

export interface TeamAssignable {
  assignToTeam(
    team: { id: string },
    options?: TeamAssignableOptions
  ): Promise<void>;
}

export function TeamAssignable(originalClass: {
  new (...args: any[]): ApplicationModel;
}): any {
  return class extends originalClass implements TeamAssignable {
    /**
     * Assigns a record to a team.
     */
    async assignToTeam(
      team: { id: string },
      options: TeamAssignableOptions = {}
    ) {
      const { resetAttributes = false, query = this.query } = options;
      const { id, typename } = this;

      let assignToTeamFragment = new Fragment(
        'assignToTeam',
        'mutation'
      ).argument(
        'attributes',
        {
          record: { id, typename },
          team: { id: team.id },
        },
        'AssignToTeamAttributes!'
      );

      if (options?.args) {
        Object.entries(options.args).forEach(([key, value]) => {
          assignToTeamFragment = assignToTeamFragment.argument(key, value);
        });
      }

      if (resetAttributes) {
        assignToTeamFragment = assignToTeamFragment.fragment(
          new Fragment('record').fragment(query.buildQueryFragment().union())
        );
      }

      const response = await ApplicationModel.mutate(assignToTeamFragment, {
        batcher: options.batcher,
      });

      // Update the record's attributes
      if (resetAttributes) {
        this.resetAttributes(
          response.assignToTeam.record,
          {},
          { undirtyAllAttributes: false }
        );
      }
    }
  };
}
